import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

function CardAuthor({ img, name, date, min, link }) {
  return (
    <Wrapper>
      <img src={img} alt={name} />
      <div className="content">
        <NavLink to={`/profile/${link}`}>{name}</NavLink>
        <div className="flex">
          <span>{date}</span>
          <img
            src="https://img.icons8.com/ios-glyphs/30/a0aec0/visible--v1.png"
            style={{ width: "18px", margin: "0 5px" }}
          />
          <span className="flex"> {min} views</span>
        </div>
      </div>
    </Wrapper>
  );
}

export default CardAuthor;

const Wrapper = styled.div`
  margin-top: 32px;
  display: flex;
  gap: 16px;
  align-items: center;

  @media (max-width: 767px) {
    margin-top: 12px;
  }
  a {
    font-weight: bold;
    @media (max-width: 767px) {
      font-size: 12px;
    }
  }
  a,
  & {
    font-family: "Hind", sans-serif;
    font-size: 1rem;
    line-height: 1.8;
    font-size: 0.875rem;
    color: #718096;
    text-decoration: none;
  }
  .flex span:last-child,
  .flex img {
    @media (max-width: 767px) {
      display: none;
    }
  }
  svg {
    margin-left: 10px;
    margin-right: 4px;
    margin-bottom: 2px;
    font-size: 14px;
  }
  .content {
    @media (max-width: 767px) {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      width: 100%;
      a,
      span {
        font-size: 10px;
      }
    }
  }
  & > img {
    width: 48px;
    height: 48px;
    object-fit: cover;
    object-position: center;
    border-radius: 50%;
    flex: 0 0 48px;
    background-color: #718096;
    overflow: hidden;
    @media (max-width: 767px) {
      display: none;
    }
  }
`;
